import { ReferencedEntry } from 'contentful';

import { SpeedBumpList } from 'src/api/contentful/contentTypes.shop';
import { fetchEntries } from 'src/api/contentful/fetchEntries';
import { get, isEntry } from 'src/utils/EntryUtil';
import { Environment, isDevEnvironment } from 'src/utils/Environment';

const SPEEDBUMP_ENTRY_ID = isDevEnvironment ? '3O2jLKdrrGSOQaggw4uWcQ' : 'Z6i77lNMS44UKUMYY6uUu';

export async function fetchSpeedBumpList(locale: string, api = Environment.current.shopContentApi) {
  const speedbumpLists = await fetchEntries<SpeedBumpList>(locale, {
    filters: { sys: { id: SPEEDBUMP_ENTRY_ID } },
    include: 2,
  }, api);

  const [ entry ] = get(speedbumpLists, 'items', []);

  return isEntry(entry) ? entry as ReferencedEntry<SpeedBumpList> : undefined;
}
